import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { formatCharacterName } from "../Utils/formatReportText";

export default function ReportCharacterRow({ item, onPress }) {
  return (
    <Pressable accessibilityRole="button" onPress={onPress} style={styles.row}>
      <View style={styles.copy}>
        <Text style={styles.name}>{formatCharacterName(item.name)}</Text>
        <Text style={styles.mutedText}>{item.total_indicators} indikator</Text>
      </View>
      <View style={styles.scoreColumn}>
        <Text style={styles.scoreText}>{item.point}%</Text>
        <View style={styles.scoreTrack}>
          <View style={[styles.scoreValue, { width: `${item.point}%` }]} />
        </View>
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: { minHeight: 42, flexDirection: "row", alignItems: "center", gap: 12 },
  copy: { flex: 1 },
  name: { color: "#5423B5", fontFamily: "Archivo-Bold", fontSize: 12 },
  mutedText: { marginTop: 2, color: "#999999", fontFamily: "Archivo-Regular", fontSize: 11 },
  scoreColumn: { width: "31%", alignItems: "flex-end", gap: 2 },
  scoreText: { color: "#48B920", fontFamily: "Archivo-Bold", fontSize: 12 },
  scoreTrack: { width: "100%", height: 11, borderRadius: 6, backgroundColor: "#EAEAEA", overflow: "hidden" },
  scoreValue: { height: "100%", borderRadius: 6, backgroundColor: "#48B920" },
});